// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='Archive External Modal'] .container-mt {\r\n    display: flex;\r\n    margin-top: 20px;\r\n  }\r\n  [name='Archive External Modal'] .container-mt>div {\r\n    flex-basis: 50%;\r\n    align-items: baseline;\r\n  }\r\n  [name='Archive External Modal'] .mt-item-1 {}\r\n  [name='Archive External Modal'] .mt-item-2 {\r\n    justify-content: flex-end;\r\n  }", ""]);
// Exports
module.exports = exports;
